import type { UseMutationResult } from '@tanstack/react-query';
import { ZfBox, ZfCheckbox } from '@zafire/react';
import type { AxiosError } from 'axios';
import type { FunctionComponent } from 'react';
import { useTranslation } from 'react-i18next';
import type { ItemSettingsDto, PanelSettingsDto } from '../../../app/api/generated/client';
import type { CashOccurrenceType } from '../../../app/enums';

interface ILiquidityCashflowSelectAllProps {
    cashOccurrenceType: CashOccurrenceType;
    settings?: PanelSettingsDto;
    cashflowItems?: ItemSettingsDto[];
    selectAllItems: UseMutationResult<PanelSettingsDto, AxiosError, boolean>;
}

export const LiquidityCashflowSelectAll: FunctionComponent<ILiquidityCashflowSelectAllProps> = ({ settings, cashflowItems, selectAllItems }) => {
    const { t } = useTranslation();

    const panelEnabled = !!settings?.enabled;
    const items = cashflowItems ?? settings?.itemsSettings ?? [];
    const selectableItems = items.filter((item) => !item.enforceDisable);
    const allSelected = selectableItems.length > 0 && selectableItems.every((item) => !!item.enabled);

    const handleSelectAll = (checked: boolean) => selectAllItems.mutate(checked);

    return (
        <ZfBox style={{ margin: 'var(--padding-vertical-xs) var(--padding-horizontal-sm)' }}>
            <ZfCheckbox
                label={t('liquidityCalculatorSettings.selectAll')}
                checked={allSelected}
                disabled={!panelEnabled || selectableItems.length === 0}
                onCheckboxCheck={(event: CustomEvent<boolean>) => handleSelectAll(event.detail)}
            />
        </ZfBox>
    );
};
